<script lang="ts" setup>
import PickUpPoint from '~/enums/pick-up-point'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()

const shippingData = computed(() => cartStore.shippingData)
</script>

<template>
  <BlockWithBorder>
    <div class="h4">
      Самовывоз
    </div>

    <table>
      <tbody>
        <tr>
          <th class="w-px whitespace-nowrap">
            Пункт самовывоза
          </th>
          <td>{{ PickUpPoint.getName(shippingData.pickUpPointId) }}</td>
        </tr>
        <tr>
          <th class="w-px whitespace-nowrap">
            Информация о&nbsp;пункте
          </th>
          <td class="pre-wrap">
            {{ PickUpPoint.getDescription(shippingData.pickUpPointId) }}
          </td>
        </tr>
        <tr>
          <th class="w-px whitespace-nowrap">
            Срок хранения
          </th>
          <td>5&nbsp;дней</td>
        </tr>
      </tbody>
    </table>
  </BlockWithBorder>
</template>
